/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="equipment.module.ts" />
module Meevo.Plugins.Equipment {
    class EquipmentController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',

            "meevo.components.busy.BusyService",
            "$translate"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

        }

        /**
       * Creates the context for editing/adding an item.
       * @return {}
       */
        createContext(): void {
            let rc = this;
            rc.busyService.start();
            rc.securityService.checkSection(rc.meevoSecurityKeys.DATA_EQUIPMENT).then(() => {
                rc.busyService.stop();
                rc.context = new equipmentContext(rc.appSettings, rc.dataService, rc.modalService, rc.identityService, rc.loggingService, this.securityService, rc.trackingService, rc.$rootScope);
                rc.context.activate(rc.selectedItemId, null, rc.asLocationId);
                rc.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                }
                // Use translate service to populate field list
                this.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false },
                    ];
            }).catch(() => {
                this.busyService.stop();
            });
        }

    }

    angular.module("meevo.plugins.equipment")
        .controller("meevo.plugins.equipment.EquipmentController", EquipmentController);
}